import { useLayoutEffect } from "react";
import { Container } from "@mui/material";
import { CompanyLogo } from "../companyLogo/CompanyLogo";
import { useFreyaSetup } from "../../hooks/useFreyaSetup";
import { ComponentWithChildren } from "../../../../common/types";
import { containerStyles } from "./FreyaContainer.styles";
import { FreyaLastConnectionDateTimeIndicator } from "../freyaLastConnectionDateTimeIndicator/FreyaLastConnectionDateTimeIndicator";
import { FreyaOnlineStatusIndicator } from "../freyaOnlineStatusIndicator/FreyaOnlineStatusIndicator";

export const FreyaContainer: ComponentWithChildren = ({ children }) => {
  const { checkProducts, isLoading } = useFreyaSetup();

  useLayoutEffect(() => {
    checkProducts();
  }, []);

  if (isLoading) {
    return null;
  }

  return (
    <Container sx={{ ...containerStyles, pt: 0, mt: 0 }}>
      <CompanyLogo />
      {children}

      <FreyaLastConnectionDateTimeIndicator />
      <FreyaOnlineStatusIndicator />
    </Container>
  );
};
